import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
  FC,
} from 'react';

interface MobileNavContextType {
  isMobile: boolean;
  isMobileNavOpen: boolean;
  openMobileNav: () => void;
  closeMobileNav: () => void;
}

const MobileNavContext = createContext<MobileNavContextType>({
  isMobile: false,
  isMobileNavOpen: false,
  openMobileNav: () => {},
  closeMobileNav: () => {},
});

export const useMobileNav = () => useContext(MobileNavContext);

export const MobileNavProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const openMobileNav = useCallback(() => setIsMobileNavOpen(true), []);
  const closeMobileNav = useCallback(() => setIsMobileNavOpen(false), []);

  return (
    <MobileNavContext.Provider
      value={{ isMobile, isMobileNavOpen, openMobileNav, closeMobileNav }}
    >
      {children}
    </MobileNavContext.Provider>
  );
};
